import { DatePipe } from '@angular/common'
import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatDialog } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { RouterModule } from '@angular/router'
import { LegalDialogComponent } from '../legal-dialog/legal-dialog.component'

@Component({
  selector: 'lib-nav-action-list',
  imports: [MatButtonModule, MatIconModule, MatTooltipModule, DatePipe, RouterModule],
  templateUrl: './nav-action-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './nav-action-list.component.scss',
})
export class NavActionListComponent {
  private readonly dialog = inject(MatDialog)

  readonly now = new Date()

  openLegalDialog() {
    this.dialog.open(LegalDialogComponent)
  }
}
